import type { ReactNode } from 'react';
import { useGameState } from '../hooks/useGameState';

interface LayoutProps {
  children: ReactNode;
  current: 'home' | 'collection' | 'gacha' | 'shop';
  onNavigate: (next: 'home' | 'collection' | 'gacha' | 'shop') => void;
}

export function Layout({ children, current, onNavigate }: LayoutProps) {
  const { state } = useGameState();
  return (
    <div className="app">
      <header className="app__header">
        <div className="app__title">パワーストーンコレクション</div>
        <div className="app__energy" aria-label="神秘エネルギー">
          ✦ 神秘エネルギー <strong>{state.daily.energy}</strong>
        </div>
      </header>
      <main className="app__main">{children}</main>
      <nav className="app__nav" aria-label="メインナビ">
        <button
          className={`app__nav-item ${current === 'home' ? 'is-active' : ''}`}
          onClick={() => onNavigate('home')}
          type="button"
        >
          ホーム
        </button>
        <button
          className={`app__nav-item ${current === 'collection' ? 'is-active' : ''}`}
          onClick={() => onNavigate('collection')}
          type="button"
        >
          コレクション
        </button>
        <button
          className={`app__nav-item ${current === 'gacha' ? 'is-active' : ''}`}
          onClick={() => onNavigate('gacha')}
          type="button"
        >
          ガチャ
        </button>
        <button
          className={`app__nav-item ${current === 'shop' ? 'is-active' : ''}`}
          onClick={() => onNavigate('shop')}
          type="button"
        >
          ショップ
        </button>
      </nav>
    </div>
  );
}
